import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useUser from '../../hooks/useUser';
import CEOSalesReports from './ceo/SalesReports';
import AdminSalesReports from './admin/SalesReports';
import ManagerSalesReports from './manager/SalesReports';
import { clearError } from '../../store/slices/salesReportsSlice';
import { clearErrors as clearCategoryErrors } from '../../store/slices/categoryWiseReportsSlice';

const SalesReports = () => {
    const dispatch = useDispatch();
    const { userRole } = useUser();

    useEffect(() => {
        dispatch(clearError());
        dispatch(clearCategoryErrors());
    }, [dispatch]);

    // Get role from localStorage as fallback
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';

    // Render based on role
    if (roleLower === 'ceo') {
        return <CEOSalesReports />;
    } else if (roleLower === 'admin') {
        return <AdminSalesReports />;
    } else if (roleLower === 'manager') {
        return <ManagerSalesReports />;
    } else {
        // Default to manager view if role is not recognized
        return <ManagerSalesReports />;
    }
};

export default SalesReports;
